import { action, makeObservable, observable } from 'mobx';
import * as yup from 'yup';
import _, { filter } from 'lodash';
import moment from 'moment';
import countyRegions from '../../data/countyRegion.json'
import rentalAssistanceProgram from '../../data/RentalAssistanceProgram.json';
import questions from '../Question';

export class AwardeeStore {

  definedErrorCount = 3;

  @observable blocking;

  @observable submissionErrorCount = 0;

  /* Provider and Awardee Information */

  @observable providerInformation = {
    agencyName: '',
    contactFirst: '',
    contactLast: '',
    contactEmail: '',
    contactPhone: ''
  }

  @observable awardeeInformation = {
    awardeeFirst: '',
    awardeeLast: '',
    awardeePreferredName: '',
    awardeeDOB: '',
    awardeeProvOneId: '',
    awardeePhone: '',
    awardeePhoneType: '',
    awardeeMailingAddr: '',
    awardeeCity: '',
    awardeeState: 'WA',
    awardeeZip: '',
    awardeeCounty: '',
    awardeeRentalAssistanceProgram: '',
    awardeRentalAssisProgramStartDate: '',
    awardeRentalAssisProgramEndDate: '',
    awardeRentalAssisProgramAmount: '',
    awardeRentalAssisProgramNotes: ''

  }

  @observable awardeeMonthlyGross = '';

  @observable incomeSourceCategories = [];

  @observable incomeSourceData = [];

  @observable documentupload = [];

  @observable documentUploadDetails = new Array(16).fill({});

  @observable Landlorddoc=[];

  @observable selectdocumentName= ''; 

  @observable selectTextdocumentName='';

  @observable aShortTermRental = '';

  @observable aMiscExpenses = '';

  @observable housingDescription = '';

  @observable aOtherHousingAssist = '';
  @observable countyRegions = [];

  @observable rentalAssistanceProgram = [];

  @observable uploadProviderInformation = {
    agencyName: '',
    contactFirst: '',
    contactLast: '',
    contactEmail: '',
    contactPhone: ''
  }

  @observable uploadAwardeeInformation = {
    awardeeFirst: '',
    awardeeLast: '',
    awardeeDOB: '',
    awardeeProvOneId: '',
  }

  @observable housingInfo = {
    county: '',
    unitSize: '',
		modifications:'',
		reasonableAccommodations:'',
    walkerAndWheelChair: [],
    wheelchairType: '',
    wheelchairWidth: '',
    otherPreferences: '',
    otherHouseHoldPerson: '',
    peopleLiving: '',
    peopleLivingDetails: []
}

@observable allAcknowledgements =  [
    {
      "AcknowledgementCd": "ACK01",
      "Acknowledgement": "I, the FCS-SH Provider, worked with my enrollee to share accurate information to the best of my knowledge for the purpose of connecting the enrollee to the AHAH Rental Assistance Program.*",
      "selected": ""
    },
    {
      "AcknowledgementCd": "ACK02",
      "Acknowledgement": "I, the enrollee, confirm that all answers have been provided to the best of my knowledge.*",
      "selected": ""
    },
    {
      "AcknowledgementCd": "ACK03",
      "Acknowledgement": "I understand that the information on this assessment will be shared with the Department of Commerce, Health Care Authority (HCA), landlords, property managers, and/or their third-party administrator solely for the purposes of connecting me to housing that aligns with my preferences and for program monitoring and evaluation.*",
      "selected": ""
    },
    {
      "AcknowledgementCd": "ACK04",
      "Acknowledgement": "I consent to my participation in Apple Health and Homes Rental Assistance Program.*",
      "selected": ""
    },
    {
      "AcknowledgementCd": "ACK05",
      "Acknowledgement": "Verbal consent was received from the awardee.*",
      "selected": ""
    }
  ]

  @observable acknowledgementInfo = {
    consentDate: '',
    consentTime: ''
  }

  @observable additionalInfo = {
    shortTermRentalRadio: '',
    shortTermRentalDetails:'',
    moneyManagerRadio:'',
    oweMoneyRadio:'',
    oweMoneyDetails:''
  }

  @observable phoneTypesList = [
    {
      id: "Select",
      value: ''
    },
    {
      id: 'Home',
      value: 'Home'
    },
    {
      id: 'Cell',
      value: 'Cell'
    },
    {
      id: 'Work',
      value: 'Work'
    },
    {
      id: 'Case Manager',
      value: 'Case Manager'
    },
    {
      id: 'Family Member',
      value: 'Family Member'
    },
    {
      id: 'Friend',
      value: 'Friend'
    },
    {
      id: 'Guardian',
      value: 'Guardian'
    },
    {
      id: 'Other',
      value: 'Other'
    }
  ]

  @observable awardeeMiscExpenseList = [];

  @observable showErrorModal = false;

  @observable confirmationId = '';

  @observable countyList = []

  livingPersonValidation = {
    firstName: yup.string().required('First Name is required!').matches(/^[A-Za-z0-9 \',\^\-ÄäÖöÜü]+$/, 'First Name should be alpha-numeric'),
    lastName: yup.string().required('Last Name is required!').matches(/^[A-Za-z0-9 \',\^\-ÄäÖöÜü]+$/, 'Last Name should be alpha-numeric'),
    age: yup.string().required('Age is required!').matches(/^\d{1,3}/, 'Invalid Format!'),
    phone: yup.string().required('Phone Number is required!').matches(/^\d{10}$/, 'Phone Number must be 10 digits with no hyphens'),
    relationship: yup.string().required('Relationship is required!').matches(/^[A-Za-z0-9 \',\^\-ÄäÖöÜü]+$/, 'Relationship should be alpha-numeric'),
  }

  /* Provider and Awardee Information */

  @observable awardeeHousingPages = [
    {title: "Provider & Awardee", state: 'stepwizard-step active', href: '#providerinfo', key: 0},
    {title: "Housing Profile", state: 'stepwizard-step disabled', href: '#housingprofile', key: 1},
    {title: "Additional Questions", state: 'stepwizard-step disabled', href: '#additionalquestions', key: 2},
    {title: "Upload Documents" , state:'stepwizard-step disabled', href: '#documents', key: 3},
    {title: "Acknowledgements", state: 'stepwizard-step disabled', href: '#acknowledgements', key: 4},
    {title: "Review & Submit", state: 'stepwizard-step disabled', href: '#reviewAndSubmit', key: 5},
  ]

  @action setAwardeeHousingPageStatus(pageKey, pageState) {
    const page = _.find(this.awardeeHousingPages, page => page.href === pageKey);
    const pageStateString = `stepwizard-step ${pageState}`;
    page.state = pageStateString;
  }

  // upload awardee documents pages

  @observable uploadAwardeeHousingPages = [
    {title: "Provider & Awardee", state: 'stepwizard-step active', href: '#providerAndAwardee', key: 0},
    {title: "Upload Documents", state:'stepwizard-step disabled', href: '#documentsVoucher', key: 1},
    {title: 'Review & Submit', state: 'stepwizard-step disabled', href: '#uploadReviewAndSubmit', key: 2}   
  ]

  @observable completedSteps = {
  providerinfo: false,
  providerAndAwardee: false,
  housingprofile: false,
  additionalquestions: false,
  acknowledgements: false,
  documents: false,
  documentsVoucher: false,
  reviewAndSubmit: false,
  uploadReviewAndSubmit: false,
  confirmation: false,
  uploadvoucherconfirmation: false,
};

isStepAllowed(step) {
  // Main flow: providerinfo -> housingprofile -> additionalquestions -> acknowledgements -> documents -> reviewAndSubmit -> confirmation
  const mainFlow = [
    "providerinfo",
    "housingprofile",
    "additionalquestions",
    "documents",
    "acknowledgements",
    "reviewAndSubmit",
    "confirmation"
  ];
  
  // Upload flow: providerAndAwardee -> documentsVoucher -> uploadReviewAndSubmit -> uploadvoucherconfirmation
  const uploadFlow = [
    "providerAndAwardee",
    "documentsVoucher",
    "uploadReviewAndSubmit",
    "uploadvoucherconfirmation"
  ];

  // Check which flow this step belongs to
  const mainIndex = mainFlow.indexOf(step);
  if (mainIndex !== -1) {
    // Step is in main flow
    const requiredSteps = mainFlow.slice(0, mainIndex);
    return requiredSteps.every(s => this.completedSteps[s]);
  }

  const uploadIndex = uploadFlow.indexOf(step);
  if (uploadIndex !== -1) {
    // Step is in upload flow
    const requiredSteps = uploadFlow.slice(0, uploadIndex);
    return requiredSteps.every(s => this.completedSteps[s]);
  }

  return false;
}


  @action setUploadAwardeeHousingPageStatus(uploadpageKey, uploadpageState) {
    const uploadpage = _.find(this.uploadAwardeeHousingPages, page => page.href === uploadpageKey);
    const uploadpageStateString = `stepwizard-step ${uploadpageState}`;
    uploadpage.state = uploadpageStateString;
  }

  @action getUploadAwardeeHousingPageStatus(uploadpageKey) {
    const uploadpage = _.find(this.uploadAwardeeHousingPages, page => page.href === uploadpageKey);
    return uploadpage?.state;
  }
  
  @action resetAwardeeHousingPageStatus() {
    this.awardeeHousingPages = [
      {title: "Provider & Awardee", state: 'stepwizard-step active', href: '#providerinfo', key: 0},
      {title: "Housing Profile", state: 'stepwizard-step disabled', href: '#housingprofile', key: 1},
      {title: "Additional Questions", state: 'stepwizard-step disabled', href: '#additionalquestions', key: 2},
      {title: "Upload Documents" , state:'stepwizard-step disabled', href: '#documents', key: 3},
      {title: "Acknowledgements", state: 'stepwizard-step disabled', href: '#acknowledgements', key: 4},
      {title: "Review & Submit", state: 'stepwizard-step disabled', href: '#reviewAndSubmit', key: 5},
    ]
  }

  @action resetUploadAwardeeHousingPageStatus() {
    this.uploadAwardeeHousingPages = [
      {title: "Provider&Awardee", state: 'stepwizard-step active', href: '#providerAndAwardee', key: 0},
      {title: "Upload Documents" , state:'stepwizard-step disabled', href: '#documents', key: 1},
      {title: 'Review & Submit', state: 'stepwizard-step disabled', href: '#uploadReviewSubmit', key: 2}   
    ]
  }

  @action setHousingInfoCounty(value) {
    this.housingInfo.county = value;
  }

  @action setAwardeeInfoCounty(value) {
    this.awardeeInformation.awardeeCounty = value;
  }

  @action setHousingInfoUnitSizeRadio(value) {
    this.housingInfo.unitSize = value;
  }
  @action setHousingModificationsRadio(value) {
    this.housingInfo.modifications = value;
  }
  @action setReasonableAccommodationsDetails(value) {
    this.housingInfo.reasonableAccommodations = value;
  }
  @action setDocumentUpload(value) {
    this.documentupload = value;
  }
  @action setLandlordDocUpload(value){
    this.Landlorddoc=value;
  }

  @action getAwardeeHousingPageStatus(pageKey) {
    const page = _.find(this.awardeeHousingPages, page => page.href === pageKey);
    return page.state;
  }

  @action getAwardeeUploadDocPageStatus(pageKey) {
    const page = _.find(this.uploadAwardeeHousingPages, page => page.href === pageKey);
    return page.state;
  }

  @action setProviderInfo(provField, val) {
    switch (provField) {
      case 'provAgencyName':
        this.providerInformation.agencyName = val;
        break;
      case 'provContactFirst':
        this.providerInformation.contactFirst = val;
        break;
      case 'provContactLast':
        this.providerInformation.contactLast = val;
        break;
      case 'provContactEmail':
        this.providerInformation.contactEmail = val;
        break;
      case 'provContactPhone':
        this.providerInformation.contactPhone = val;
        break;
      default:
        break;
    }
  }

  @action setAwardeePhoneNumber = val => {
    this.awardeeInformation.awardeePhone = val;
  }

  @action setSelectDocumentName=val =>{
    this.selectdocumentName=val;
    this.documentUploadDetails[15].customDocumentName = val;
  }
  @action setSelectTextDocName=val =>{
    this.selectTextdocumentName=val;
    this.documentUploadDetails[9].customDocumentName = val;
  }

  @action setAwardeeProvOne = val => {
    this.awardeeInformation.awardeeProvOneId = val;
  }

  @action setAwardeeDateOfBirth = value => {
    if (value !== null) {
      this.awardeeInformation.awardeeDOB = value;
    }
  }

  @action setAwardeePhoneType = value => {
    this.awardeeInformation.awardeePhoneType = value;
  }

  @action setAwardeeInfo(infoField, val) {
    switch (infoField) {
      case 'awardeeInfoFirst':
        this.awardeeInformation.awardeeFirst = val;
        break;
      case 'awardeeInfoLast':
        this.awardeeInformation.awardeeLast = val;
        break;
      case 'awardeeInfoPrefName':
        this.awardeeInformation.awardeePreferredName = val;
        break;
      case 'awardeeInfoAddr':
        this.awardeeInformation.awardeeMailingAddr = val;
        break;
      case 'awardeeInfoCity':
        this.awardeeInformation.awardeeCity = val;
        break;
      case 'awardeeInfoZip':
        this.awardeeInformation.awardeeZip = val;
        break;
      case 'awardeeInfoRentalAssisProgramAmount':
        this.awardeeInformation.awardeRentalAssisProgramAmount = val;
        break;
      case 'awardeeInfoRentalAssisProgramNotes':
        this.awardeeInformation.awardeRentalAssisProgramNotes = val;
        break;
      default:
        break;
    }
  }

  @action setAwardeeMonthlyGrossIncome = value => {
    this.awardeeMonthlyGross = value;
  }

  @action setIncomeCategories = value => {
    this.incomeSourceCategories = value;
  }

  @action setIncomeSourceData = value => {
    this.incomeSourceData = value;
  }

  @action setIncomeCatAmount = (value, index) => {
    this.incomeSourceData[index].amount = value;
  }

  @action setAShortTermRental = value => {
    this.aShortTermRental = value;
  }

  @action setAMiscExpenses = value => {
    this.aMiscExpenses = value;
  }

  @action addAwardeeMiscExpense() {
    const expense = {
      expType: '',
      amount: '',
      type: ''
    }

    this.awardeeMiscExpenseList.push(expense);
  }

  @action removeAwardeeMiscExpense(index) {
    const filteredExpenseList = this.awardeeMiscExpenseList.filter((exp, sIndex) => index !== sIndex);
    this.awardeeMiscExpenseList = filteredExpenseList;
  }

  @action setMiscExpenseType(index, value) {
    this.awardeeMiscExpenseList[index].expType = value;
  }

  @action setMiscExpenseAmount(index, value) {
    this.awardeeMiscExpenseList[index].amount = value;
  }

  @action setMiscExpenseSelected(index, value) {
    this.awardeeMiscExpenseList[index].type = value;
  }

  @action resetAwardeeMiscExpenses() {
    this.awardeeMiscExpenseList = [];
  }

  @action setHousingDescription = value => {
    this.housingDescription = value;
  }

  @action setAOtherHousing = value => {
    this.aOtherHousingAssist = value;
  }
  @action setShortTermRentalRadio = value => {
    this.additionalInfo.shortTermRentalRadio = value;
  }

  @action setMoneyManagerRadio = value => {
    this.additionalInfo.moneyManagerRadio = value;
  }

  @action setoweMoneyRadio = value => {
    this.additionalInfo.oweMoneyRadio = value;
  }

  @action setAdditionalInfoDetails(name, value) {
    switch (name) {
      case 'shortTermRentalField':
        this.additionalInfo.shortTermRentalDetails = value;
        break;
      case 'oweMoneyField':
        this.additionalInfo.oweMoneyDetails = value;
        break;

      default:
        break;
    }
  }


  @action turnOnBlocking() {
    this.blocking = true;
  }

  @action turnOffBlocking() {
    this.blocking = false;
  }

  @action setWalkerAndWheelchair(values) {
    this.housingInfo.walkerAndWheelChair = values;
  }

  @action setWheelchairType(value) {
    this.housingInfo.wheelchairType = value;
  }

  @action setWheelchairWidth(value) {
    this.housingInfo.wheelchairWidth = value;
  }

  @action setOtherPreferences(value) {
    this.housingInfo.otherPreferences = value;
  }

  @action setOtherHouseHoldPerson(value) {
    this.housingInfo.otherHouseHoldPerson = value;
  }

  @action setPeopleLiving(value) {
    this.housingInfo.peopleLiving = value;
  }

  @action updatepeopleLivingDetails() {
    const { housingInfo } = this;
    const { peopleLiving, peopleLivingDetails } = housingInfo;
    if (peopleLiving > peopleLivingDetails.length) {
      for (let i = peopleLivingDetails.length; i < peopleLiving; i++) {
        this.housingInfo.peopleLivingDetails.push({ firstName: '', lastName: '', age: '', phone: '', relationship: '' });
      }
    } else if (peopleLiving < peopleLivingDetails.length) {
      this.housingInfo.peopleLivingDetails.splice(peopleLiving);
    }
  }

  @action removeSingleLivDetail(index) {
    this.housingInfo.peopleLivingDetails.splice(index, 1)
    this.housingInfo.peopleLiving = this.housingInfo.peopleLivingDetails.length;
  }

  @action setPeopleLivingDetails(e, fieldName, index) {
    this.housingInfo.peopleLivingDetails[index][fieldName] = e;
  }

  @action setAcknowledgment(selected, index) {
    this.allAcknowledgements[index].selected = selected
  }

  @action setConsentDate(value) {
    this.acknowledgementInfo.consentDate = value;
  }

  @action setTimeConsent(value) {
    this.acknowledgementInfo.consentTime = value;
  }

  // awardee rental assist program
  @action setAwardeeRentalAssistProgram = value => {
    this.awardeeInformation.awardeeRentalAssistanceProgram = value;
  }

  @action setAwardeRentalAssisProgramStartDate = value => {
    if (value !== null) {
      this.awardeeInformation.awardeRentalAssisProgramStartDate = value;
    }
  }

  @action setAwardeRentalAssisProgramEndDate = value => {
    if (value !== null) {
      this.awardeeInformation.awardeRentalAssisProgramEndDate = value;
    }
  }

  @action incrementSubmissionErrorCount() {
    this.submissionErrorCount = this.submissionErrorCount + 1;
  }

  @action openErrorModal() {
    this.showErrorModal = true;
  }

  @action closeErrorModal() {
    this.showErrorModal = false;
  }

  @action setSingleDocumentUploadDetails(index, sinlgeDocumentUploadDetails) {
    const documentUpdates = [...this.documentUploadDetails]
    documentUpdates[index] = sinlgeDocumentUploadDetails;
    this.documentUploadDetails = documentUpdates;
  }

  @action setCountyList(list) {
    this.countyList = list;
  }

  @action getCountyListCount() {
    return this.countyList.length;
  }

  @action resetDocumentObj(index) {
    const obj = this.documentUploadDetails[index]
    if(obj && Object.keys(obj).length > 0) {
      this.documentUploadDetails[index] = {}
    }

    if (index === 9 ){
      this.selectTextdocumentName = "";
    }
    if (index === 15){
      this.selectdocumentName = "";
    }
  }

  @action resetAllDocumentObj() {
      this.documentupload = [];
      this.Landlorddoc=[];
      this.documentUploadDetails = new Array(16).fill({});
      this.selectTextdocumentName = "";
      this.selectdocumentName = "";
  }

  @action reset() {
    this.blocking = false;

    this.submissionErrorCount = 0;
    this.providerInformation = {
      agencyName: '',
      contactFirst: '',
      contactLast: '',
      contactEmail: '',
      contactPhone: ''
    }
  
    this.awardeeInformation = {
      awardeeFirst: '',
      awardeeLast: '',
      awardeePreferredName: '',
      awardeeDOB: '',
      awardeeProvOneId: '',
      awardeePhone: '',
      awardeePhoneType: '',
      awardeeMailingAddr: '',
      awardeeCity: '',
      awardeeState: 'WA',
      awardeeZip: '',
      awardeeCounty: '',
      awardeeRentalAssistanceProgram: '',
      awardeRentalAssisProgramStartDate: '',
      awardeRentalAssisProgramEndDate: '',
      awardeRentalAssisProgramAmount: '',
      awardeRentalAssisProgramNotes: ''
  
    }
  
    this.awardeeMonthlyGross = '';
  
    this.incomeSourceCategories = [];
  
    this.aShortTermRental = '';
  
    this.aMiscExpenses = '';
  
    this.housingDescription = '';
  
    this.aOtherHousingAssist = '';
  
    this.housingInfo = {
      county: '',
      unitSize: '',
      modifications:'',
      reasonableAccommodations:'',
      walkerAndWheelChair: [],
      wheelchairType: '',
      wheelchairWidth: '',
      otherPreferences: '',
      otherHouseHoldPerson: '',
      peopleLiving: '',
      peopleLivingDetails: []
  }

  this.allAcknowledgements =  [
      {
        "AcknowledgementCd": "ACK01",
        "Acknowledgement": "I, the FCS-SH Provider, worked with my enrollee to share accurate information to the best of my knowledge for the purpose of connecting the enrollee to the AHAH Rental Assistance Program.*",
        "selected": ""
      },
      {
        "AcknowledgementCd": "ACK02",
        "Acknowledgement": "I, the enrollee, confirm that all answers have been provided to the best of my knowledge.*",
        "selected": ""
      },
      {
        "AcknowledgementCd": "ACK03",
        "Acknowledgement": "I understand that the information on this assessment will be shared with the Department of Commerce, Health Care Authority (HCA), landlords, property managers, and/or their third-party administrator solely for the purposes of connecting me to housing that aligns with my preferences and for program monitoring and evaluation.*",
        "selected": ""
      },
      {
        "AcknowledgementCd": "ACK04",
        "Acknowledgement": "I consent to my participation in Apple Health and Homes Rental Assistance Program.*",
        "selected": ""
      },
      {
        "AcknowledgementCd": "ACK05",
        "Acknowledgement": "Verbal consent was received from the awardee.*",
        "selected": ""
      }
    ]
  
    this.acknowledgementInfo = {
      consentDate: '',
      consentTime: ''
    }
  
    this.additionalInfo = {
      shortTermRentalRadio: '',
      shortTermRentalDetails:'',
      moneyManagerRadio:'',
      oweMoneyRadio:'',
      oweMoneyDetails:''
    }

    this.awardeeHousingPages = [
      {title: "Provider & Awardee", state: 'stepwizard-step active', href: '#providerinfo', key: 0},
      {title: "Housing Profile", state: 'stepwizard-step disabled', href: '#housingprofile', key: 1},
      {title: "Additional Questions", state: 'stepwizard-step disabled', href: '#additionalquestions', key: 2},
      {title: "Upload Documents" , state:'stepwizard-step disabled', href: '#documents', key: 3},
      {title: "Acknowledgements", state: 'stepwizard-step disabled', href: '#acknowledgements', key: 4},
      {title: "Review & Submit", state: 'stepwizard-step disabled', href: '#reviewAndSubmit', key: 5},
    ]

  this.completedSteps = {
  // Main flow steps
  providerinfo: false,
  housingprofile: false,
  additionalquestions: false,
  documents: false,
  acknowledgements: false,
  reviewAndSubmit: false,
  confirmation: false,
  // Upload flow steps
  providerAndAwardee: false,
  documentsVoucher: false,
  uploadReviewAndSubmit: false,
  uploadvoucherconfirmation: false,
};

    this.showErrorModal = false;

    this.awardeeMiscExpenseList = [];

    this.documentUploadDetails = new Array(16).fill({});
  }

  constructor() {
    makeObservable(this)
    this.countyRegions = countyRegions;
    this.rentalAssistanceProgram = rentalAssistanceProgram;
  }

  getIndividualInititalValues = () => {
		const {allAcknowledgements} = this;
		const validationObj = {}
    const initialValueObj = {}
    allAcknowledgements.forEach((ack) => {
			initialValueObj[`acknowlegmentgroup-${ack.AcknowledgementCd}`] = (ack.selected && ack.selected.map(x=>x)) || [];
            validationObj[`acknowlegmentgroup-${ack.AcknowledgementCd}`] = yup.array().isRequired(true, '')
		});
		return {validationObj, initialValueObj};
	}

  getAhahFormData = () => {
    const data = {
      "application": "Provider Portal - Public",
      "state": "WA",
      "brand": "AGP",
      "serviceType": "Awardee Profile",
      "dateReceived": moment().format("YYYY-MM-DD"),
      'initialOrReauth': 'Initial Assessment'
    }

    // Housing Profile
    const housingInformation = {
      "county": this.housingInfo.county
    }

    // Provider Information
    const providerAgencyNameTmp = this.getProvAgencyName(this.providerInformation);
    const provAgencyId = this.getProvAgencyId(this.providerInformation)
    const provAgencyObj = provAgencyId ? {"id": this.getProvAgencyId(this.providerInformation)} : {};
    const providerAgency = {
      ...provAgencyObj,
      "name": providerAgencyNameTmp,
      "reporter": {
        "firstName": this.providerInformation.contactFirst,
        "lastName": this.providerInformation.contactLast,
        "email": this.providerInformation.contactEmail,
        "phoneNumber": this.providerInformation.contactPhone
      }
    }
    data.providerAgency = providerAgency;

    // Awardee Information
    const enrolleeInfo = {
      "firstName": this.awardeeInformation.awardeeFirst,
      "lastName": this.awardeeInformation.awardeeLast,
      "preferredName": this.awardeeInformation.awardeePreferredName,
      "dateOfBirth": this.awardeeInformation.awardeeDOB,
      "providerOneId": this.awardeeInformation.awardeeProvOneId + 'WA',
      "phoneNumber": this.awardeeInformation.awardeePhone,
      "phoneNumberType": this.awardeeInformation.awardeePhoneType,
      "address": this.awardeeInformation.awardeeMailingAddr,
      "city": this.awardeeInformation.awardeeCity,
      "county": this.awardeeInformation.awardeeCounty,
      "state": "WA",
      "zip": this.awardeeInformation.awardeeZip,
    }
    data.enrollee = enrolleeInfo;

    const questionsData = [];

    questions.map((question, index) => {
      this.setQuestionAnswers(question, questionsData)
    })

    if(this.housingInfo.peopleLiving > 0) {
      const livingDetails = this.housingInfo.peopleLivingDetails.map((livingDetail) => {
        return {
          "firstName": livingDetail.firstName,
          "LastName": livingDetail.lastName,
          "Age": livingDetail.age,
          "Phone": livingDetail.phone,
          "Relationship": livingDetail.relationship
        }
      })
      housingInformation.livingWith = livingDetails;
    }

    data.housingInformation = housingInformation;

    data.questions = questionsData;
    
    const enrolleeConsent = {
      "date": this.acknowledgementInfo.consentDate,
      "time": this.acknowledgementInfo.consentTime,
      "Acknowledgements": this.allAcknowledgements.filter(ack => ack.selected != '' && ack.selected.length > 0).map(ack => {return {"ecCode": ack.AcknowledgementCd, "ecValue": ack.Acknowledgement}})
    };
    data.enrolleeConsent = enrolleeConsent;

    const attachments = this.documentUploadDetails.filter(uploadObj => uploadObj 
      && uploadObj.percetComp && uploadObj.percetComp === 100)
      .map(uploadObj => {return {"documentName": uploadObj.documentName === "Other" ? uploadObj.customDocumentName : 
        uploadObj.documentName, "fileName": uploadObj.updatedFileName}});
    data.attachments = attachments;
    return data;
  }

  getUploadVoucherFormData = () => {
    const data = {
      application: 'Provider Portal - Public',
      state: 'WA',
      brand: 'AGP',
      serviceType: 'Awardee Profile',
      dateReceived: moment().format('YYYY-MM-DD'),
      initialOrReauth: 'Reauthorization'
    }

    // Provider Information
    const providerAgencyNameTmp = this.getProvAgencyName(this.providerInformation);
    const provAgencyId = this.getProvAgencyId(this.providerInformation)
    const provAgencyObj = provAgencyId ? {"id": this.getProvAgencyId(this.providerInformation)} : {};
    const providerAgency = {
      ...provAgencyObj,
      name: providerAgencyNameTmp,
      reporter: {
        firstName: this.providerInformation.contactFirst,
        lastName: this.providerInformation.contactLast,
        email: this.providerInformation.contactEmail,
        phoneNumber: this.providerInformation.contactPhone
      }
    }

    data.providerAgency = providerAgency;

    const enrolleeInfo = {
      firstName: this.awardeeInformation.awardeeFirst,
      lastName: this.awardeeInformation.awardeeLast,
      preferredName: this.awardeeInformation.awardeePreferredName,
      dateOfBirth: this.awardeeInformation.awardeeDOB,
      providerOneId: this.awardeeInformation.awardeeProvOneId + 'WA',
      phoneNumber: this.awardeeInformation.awardeePhone,
      phoneNumberType: this.awardeeInformation.awardeePhoneType,
      address: this.awardeeInformation.awardeeMailingAddr,
      city: this.awardeeInformation.awardeeCity,
      county: this.awardeeInformation.awardeeCounty,
      state: 'WA',
      zip: this.awardeeInformation.awardeeZip
    }
    data.enrollee = enrolleeInfo;

    const attachments = this.documentUploadDetails.filter(uploadObj => uploadObj 
      && uploadObj.percetComp && uploadObj.percetComp === 100)
      .map(uploadObj => {return {"documentName": uploadObj.documentName === "Other" ? uploadObj.customDocumentName : 
        uploadObj.documentName, "fileName": uploadObj.updatedFileName}});
    data.attachments = attachments;
    return data;
  }

  getAttachmentCount = () =>{
    return this.documentUploadDetails.filter(uploadObj => uploadObj 
      && uploadObj.percetComp && uploadObj.percetComp === 100).length;
  }

  setQuestionAnswers = (questionObj, questions) => {
    if(questionObj.isRequired !== undefined && !((questionObj.isRequired.bind(this))())) {
      return;
    }
    let actualValue;
    if(questionObj.getValue) {
      const getValue = questionObj.getValue.bind(this);
      actualValue = getValue();
    }
    const answers = [];
    const {getValue, isRequired, addAdditionalAnswers, updateAnswerKvs, ...data} = questionObj;
    const finalQuesObj = JSON.parse(JSON.stringify(data));
    if(questionObj.answerKVs.length > 1) {
      if(actualValue) {
        questionObj.answerKVs.forEach((val) => {
          if(typeof actualValue === "string" && val.text.toUpperCase() === actualValue.toUpperCase()) {
            answers.push(val.id);
          } else if(typeof actualValue === "object") {
            if(actualValue.some(key => key.includes(val.text) || key.toUpperCase().includes(val.text.toUpperCase()))) {
              answers.push(val.id);
            }
          }
        });
      }
      finalQuesObj.answers = answers;
    } else if((questionObj.answerKVs.length === 1 || questionObj.answerKVs.length === 0) && actualValue) {
      answers.push(actualValue);
      finalQuesObj.answers = answers;
    }
    if(questionObj.addAdditionalAnswers) {
      answers.push(...(questionObj.addAdditionalAnswers.bind(this, questionObj.answerKVs))());
      finalQuesObj.answers = answers;
    }
    questions.push(finalQuesObj);
  }

  getProvAgencyName(providerInformation) {
    if(!providerInformation.agencyName)
      return "";

    if (typeof providerInformation.agencyName === 'string') {
      return this.providerInformation.agencyName;
    }
    return this.providerInformation.agencyName ? this.providerInformation.agencyName.label : '';
  }

  getProvAgencyId(providerInformation) {
    if(!providerInformation.agencyName)
      return undefined;

    if (typeof providerInformation.agencyName === 'string') {
      return undefined;
    }
    return this.providerInformation.agencyName ? this.providerInformation.agencyName.value : undefined;
  }

  getProvAgencyAbbr(providerInformation) {
    if(!providerInformation.agencyName)
      return undefined;

    if (typeof providerInformation.agencyName === 'string') {
      return undefined;
    }
    const agencyAbbr =  this.providerInformation.agencyName ? this.providerInformation.agencyName.abbr : undefined;
    return agencyAbbr.replace(/ /g, '');
  
  }
}

export default new AwardeeStore();
